/**
 * Страница 404: отображается при переходе на несуществующий роут
 */
import { Link } from 'react-router-dom';
import { MainLayout } from '@/components/layout/MainLayout';
import { Button } from '@/components/ui';

export function NotFoundPage() {
  return (
    <MainLayout>
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-neutral-900 mb-4">404</h1>
          <p className="text-neutral-600 mb-6">Страница не найдена</p>
          <Link to="/">
            <Button>Вернуться на главную</Button>
          </Link>
        </div>
      </div>
    </MainLayout>
  );
}

